export default __webpack_public_path__ + "static/media/CustomMaps.44db03b2.mp4";